import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import Icon from './Icon';

class CollapsibleItem extends React.Component {

    static propTypes = {
        header: PropTypes.node.isRequired,
        icon: PropTypes.string,
        onSelect: PropTypes.func,
        onOpen: PropTypes.func,
        /**
         * If the item is expanded by default
         * @default false
         */
        expanded: PropTypes.bool,
        /**
         * The value to pass to the onSelect callback
         */
        eventKey: PropTypes.node,
        /**
         * The node type of the header
         * @default a
         */
        node: PropTypes.node,

        children: PropTypes.node
    };

    //static defaultProps = {
    //    expanded: false
    //};

    constructor(props) {
        super(props);
        this.state = {expanded: props.expanded};
        this.handleClick = this.handleClick.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
    }

    handleClick() {
        if (this.props.onSelect) {
            this.props.onSelect(this.props.eventKey);
        } else {
            if (!this.state.expanded && this.props.onOpen) {
                this.props.onOpen(this.props.eventKey);    
            }
            this.setState({expanded: !this.state.expanded});
        }
    }

    renderBody() {
        let style = {display: 'block'};
        return (
            <div className="collapsible-body" style={style}>
                {this.props.children}
            </div>
        );
    }

    renderIcon(icon) {
        return <Icon>{icon}</Icon>;
    }

    render() {
        let {node, header, expanded, icon, children, ...props} = this.props;
        let Comp = node || 'div';

        expanded = (typeof expanded !== 'undefined') ? expanded : this.state.expanded;

        let classes = {
            'collapsible-header': true
        };

        return (
            <li {...props}>
                <Comp className={cx(classes)} onClick={this.handleClick}>
                    {icon ? this.renderIcon(icon) : null}
                    {header}
                </Comp>
                {expanded ? this.renderBody() : null}
            </li>
        );
    }

}

export default CollapsibleItem;